export const COLOR_PALETTE: [string, string, string] = [
    '#F8DEC6',
    '#F1BE8D',
    '#9E272F',
  ]